export const timeZones = [
  'Hawaii',
  'Alaska',
  'Pacific Time (US & Canada)',
  'Arizona',
  'Mountain Time (US & Canada)',
  'Central Time (US & Canada)',
  'Eastern Time (US & Canada)',
];

export const timeZoneOptions = timeZones.map(tz => ({ value: tz, label: tz }));
